<script>
    import AnimatedInteger from "./AnimatedInteger.svelte";

    export let forderung;
    export let rendite;

    function handleKeyUp(event) {
        if (window.getSelection().toString() !== '') {
            return;
        }
        // Ignore arrow keys
        let arrows = [38, 40, 37, 39];
        if (arrows.includes(event.keyCode)) {
            return;
        }
        let input = event.target.value.replace(/[\D\s._-]+/g, "");
        input = input ? parseInt(input, 10) : 0;
        event.target.value = (input === 0) ? "" : input.toLocaleString("de-DE");
    }

    $: forderungRaw = Number(forderung.replace(/[\D\s._-]+/g, ""));
    $: forderungPretty = forderungRaw.toLocaleString('de-DE', {minimumFractionDigits: 0, maximumFractionDigits: 0});
    $: mehrumsatz = forderungRaw * 100 / rendite;


</script>

<div id="rechner-container">
    <form class="sk-input-form">
        <div class="input-group">
            <label class="little-label" for="forderung">Ein Forderungsausfall von</label>
            <span class="sk-formatted-input little-label">
                    <input id="forderung" type="text" step="any" bind:value={forderung} on:keyup={handleKeyUp}
                           placeholder="Betrag Forderungsausfall in €">
                     Euro
                </span>
        </div>
        <div class="input-group">
            <label class="little-label" for="rendite">Umsatzrendite</label>
            <span class="sk-formatted-input little-label">
                    <input id="rendite" type="number" bind:value={rendite} placeholder="Umatzrendite in %">
                     %
                </span>
        </div>
    </form>
    <div class="sk-result-panel">
        <p>Um einen Forderungsausfall in Höhe von <span class="signal"> <span>{forderungPretty}</span>&nbsp;Euro</span>
            bei einer <span class="signal">Umsatzrendite von {rendite}%</span> auszugleichen, ist ein <span
                    class="signal">Mehrumsatz von ca.
            <span>
                <AnimatedInteger animee={mehrumsatz}></AnimatedInteger>
            </span>&nbsp;Euro</span> erforderlich.
        </p>
    </div>
</div>


<style>
    #rechner-container {
        display: grid;
        grid-template-columns: 300px auto;
    }

    label {
        line-height: 140%;
        font-size: 1.125rem;
        font-weight: normal;
        padding-bottom: 0.3125rem;
        display: flex;
    }
    .little-label {
        font-size: 12px;
    }
    .signal {
        font-weight: bold;
    }
    span.sk-formatted-input {
        box-sizing: border-box;
        line-height: normal;
        margin: 0 0 1rem 0;
        padding: 0.5rem;
        border: 1px solid #ccc;
        border-radius: 3px !important;
        background: #fff;
        box-shadow: 0 0 0 0;
        height: 2.1875rem;
        margin-bottom: 1.25rem;
        padding-top: 0.75rem;
        padding-bottom: 0.75rem;
    }

    input {
        font-family: "Sparkasse Web";
        box-sizing: border-box;
        line-height: normal;
        margin: 0 0 1rem 0;
        padding: 0;
        border: none;
        border-radius: 3px !important;
        width: 5em;
        transition: all 300ms ease-out;
        background: none;
        box-shadow: 0 0 0 0;
        height: 2.1875rem;
        margin-bottom: 1.25rem;
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
        font-size: 18px;
        color: #333;
        font-weight: 400;
        font-style: normal;
    }
    input#rendite{
        width: 3em;
    }
    span.sk-formatted-input:hover {
        border: 0.0625rem solid #ed6a00;
        box-shadow: 0 0 0 0 #000;
        background: #fff;
    }
    input:focus {
        outline: none;
    }
    ::placeholder {
        color: gray !important;
    }

    form.sk-input-form {
        grid-column: 1/1;
        grid-row: 1;
        display: flex;
    }

    div.input-group {
        flex: 1 1 auto;
    }


    div.sk-result-panel {
        grid-column: 2/2;
        grid-row: 1;
    }


    @media (max-width: 600px){
        #rechner-container{
            grid-template-columns: auto;
        }

        form.sk-input-form {
            grid-column: 1/1;
            grid-row: 1;
            display: flex;
        }

        div.sk-result-panel {
            grid-column: 1/1;
            grid-row: 2;
        }
    }
</style>
